import { useState } from "react";
import { imageFileToItemDataList } from "../utils/pictureToItems";
import { uploadPicture } from "../data/PictureData";
import { AzureResult } from "../types/azureResult";
import { Receipt } from "../data/Receipt";

interface UseReceiptUploadOptions {
  onSuccess: (result: AzureResult) => void;
  onError?: (error: unknown) => void;
  setPictureUploaded: (pictureUploaded: boolean) => void;
  updateReceipt: (receipt: Partial<Receipt>) => void;
}

export const useReceiptUpload = ({
  onSuccess,
  onError,
  setPictureUploaded,
  updateReceipt,
}: UseReceiptUploadOptions) => {
  const [loading, setLoading] = useState(false);

  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || !files[0]) return;

    const file = files[0];

    setLoading(true);
    try {
      uploadPicture(file, setPictureUploaded, updateReceipt);
      const azureResult = await imageFileToItemDataList(file);
      onSuccess(azureResult);
    } catch (error) {
      console.error("Error uploading receipt:", error);
      onError?.(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    handleImageChange,
  };
};
